<template>
  <div class="resource-category-wrapper">

    <div class="resource-category-list" v-if="resCateList.length > 0">

      <el-card class="resource-category-card" v-for="(cate, cateIndex) in resCateList" :key="`res-cate-${cateIndex}`">
        <div slot="header">
          <span>{{ cate.name }}</span>
        </div>

        <div class="res-content">
          <div v-for="(res, resIndex) in cate.resource_list" :key="`res-${resIndex}`" class="res-item">
            <el-tag
              type="danger"
              size="medium">
              <el-tooltip placement="top">
                <div slot="content">
                  <span>前端标识: {{ res.code }}</span><br/>
                  <span>请求方法：{{ res.method }}</span><br/>
                  <span>请求地址：{{ res.url }}</span>
                </div>
                <span class="res-name">{{ res.name }}</span>
              </el-tooltip>
            </el-tag>
          </div>
        </div>
      </el-card>

    </div>

    <div class="empty-tips custom-wrapper"
      v-else-if="hasRes('op_resource_category_index') || hasRes('op_resource_index')">
      <div> <i class="iconfont icon-searching"></i> </div>
      <h3>您还没有权限资源，点击上方按钮即可进行添加</h3>
    </div>

    <custom-paginate
      :default-page-size="6"
      :count="resCateCount"
      @page-change="updateTableData" />

  </div>
</template>

<script>
import DialogEditOpPermission from './components/DialogEditOpPermission'
import CustomPaginate from '@/components/CustomPaginate'

import { mapState, mapGetters } from 'vuex'
import aclApi from '@/api/aclApi'

export default {
  name: 'Permission',
  components: {
    DialogEditOpPermission,
    CustomPaginate
  },
  data () {
    return {
      loading: true,
      sort: '',

      resCateList: [],
      resCateCount: 0,

      addPermDialogVisible: false,
      addPermForm: {
        name: '',
        code: '',
        resources: []
      },
      addPermRules: {
        name: [
          { required: true, message: '请输入权限的名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入权限的代号', trigger: 'blur' }
        ],
        resources: [
          { required: true, message: '请选择权限的资源', trigger: 'change' }
        ]
      },

      addResDialogVisible: false,
      addResForm: {
        name: '',
        code: '',
        method: 'GET',
        url: '/api/v1/'
      },
      addResRules: {
        name: [
          { required: true, message: '请输入权限名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入权限描述', trigger: 'blur' }
        ],
        method: [
          { required: true, message: '请选择权限的请求方法', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入权限链接', trigger: 'blur' }
        ]
      },

      editPermissionDialogVisible: false,
      editingPermission: {}
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    async updateTableData () {
      this.loading = true

      try {
        const { msg, data, rcode } = await aclApi.getOpResources({
          page: this.page,
          pageSize: this.pageSize
        })
        if (rcode !== 0) {
          this.$message({
            type: 'error',
            message: msg
          })
          return
        }
        this.resCateList = data.list
        this.resCateCount = data.count
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取权限资源列表失败'
        })
      }
    }
  },
  mounted () {
    this.updateTableData()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base";

.resource-category-wrapper {

  .resource-category-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 96%;
    margin: 40px auto 0;

    .resource-category-card {
      margin-right: 1.5rem;
      margin-bottom: 1.5rem;
      width: 30%;
      height: 280px;
      position: relative;

      .res-content {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: flex-start;
        max-height: 200px;
        overflow-y: auto;

        .res-item {
          margin: 5px 5px 0 0;
        }
      }
    }
  }

  .empty-tips {
    text-align: center;
    color: $primaryColor;

    i {
      font-size: 6rem;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/op/acl/op_resource.vue